import { RootState } from '../redux/root-reducer';

export const isVideoOverlayOpened = (state: RootState) =>
  state.fullScreenModal.lightbox;
